
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail/cosmetics-pos-billing-software",
      function () {
        return require("private-next-pages/retail/cosmetics-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail/cosmetics-pos-billing-software"])
      });
    }
  